import routeThrowComponent from './route_throw.component';

let routeThrowModule = angular.module('routeThrow', [ 
  ])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise('/route-throw');

    $stateProvider
      .state('routeThrow', {
        url: '/route-throw',
        component: 'routeThrow',
        data: {
          requireLogin: true
        },
        parent: 'app',
      });
  })

  .component('routeThrow', routeThrowComponent)

  .name;

export default routeThrowModule;


// WEBPACK FOOTER //
// ./client/app/components/route_throw/index.js